import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "./components/accordion.js";
import "./components/menuMobile.js";

import "../styles/interieurvoorbeelden.css";

handleFloatingPromise(initExpertSite());
